export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail o username',
      invalidEmailOrUsername: 'E-mail o username non valido',
      invalidPassword: 'Password non valida',
      logInToPlanka: 'Log in Planka',
      noInternetConnection: 'Nessuna connessione internet',
      pageNotFound_title: 'Pagina non trovata',
      password: 'Password',
      projectManagement: 'Gestione del progetto',
      serverConnectionFailed: 'Connesione al server fallita',
      unknownError: 'Errore sconosciuto, prova ancora',
    },

    action: {
      logIn: 'Log in',
    },
  },
};
